import { useIntl } from 'react-intl'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { Accordion } from '@b-stock/fe-core/bstock-react'
import { DocumentDtoDocTypeEnum } from '@b-stock/listing-api-client'

import { MobileAccordionWrapper } from '../ListingDetailsLayout/ui'
import Policies from './Policies'

export const PoliciesAccordion = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const { formatMessage } = useIntl()
  const personId = useDecodedAccessToken()?.personId

  if (!personId || !listing.documents) return null

  return (
    <MobileAccordionWrapper>
      <Accordion label={formatMessage({ id: 'Auction.title.policies' })} isOpen>
        <Policies
          documents={listing.documents}
          documentType={DocumentDtoDocTypeEnum.TermsOfService}
          cancellationPolicy={listing.contract?.cancellationPolicy}
        />
      </Accordion>
    </MobileAccordionWrapper>
  )
}
